export class Estado {
    codIbge: string;
    id: number;
    nome: string;
    uf: string;
}